<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between mt-4">
                            <!-- Sección Izquierda (Título) -->
                            <div>
                                <h5 class="mb-2 ms-2">Resumen de horas</h5>
                            </div>
                            <div class="text-center">
                                <h4 class="mb-0">Semana: <b>{{ formatRangeLabel(weekStartDate, weekEndDate) }}</b></h4>
                            </div>
                            <div>
                                <button class="btn btn-secondary mb-0" @click="downloadReport()"
                                    :class="!showDownloadButton ? 'disabled' : ''">
                                    <div class="d-flex align-items-center">
                                        <span>Descargar Reporte <i class="bi bi-download"></i></span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div>
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <button class="btn btn-warning mb-0" @click="changeWeek(-1)">
                                        <div class="d-flex align-items-center">
                                            <span class="ni ni-bold-left text-white"> </span>
                                            <span>Semana Anterior</span>
                                        </div>
                                    </button>
                                </div>
                                <div class="d-flex align-items-center gap-2">
                                    <input type="text" class="form-control" placeholder="Buscar Colaborador..."
                                        aria-label="Buscar" v-model="searchEmployee">
                                </div>
                                <div>
                                    <div class="d-flex gap-2 justify-content-center">
                                            <span class="badge justified-absence-indicator">Ausencia Justificada</span>
                                    </div>
                                </div>
                                <div>
                                    <button class="btn btn-warning mb-0" @click="changeWeek(1)">
                                        <div class="d-flex align-items-center">
                                            <span>Semana Siguiente</span>
                                            <span class="ni ni-bold-right text-white"> </span>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered text-center align-middle">
                                <thead>
                                    <tr>
                                        <th rowspan="2">Colaborador</th>
                                        <th colspan="3"><b>Resumen Horas</b></th>
                                        <th v-for="day in weekDays" :key="day.key" colspan="2">
                                            {{ day.label }}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>Total</th>
                                        <th>Regulares</th>
                                        <th>Extra</th>
                                        <template v-for="day in weekDays" :key="day.key">
                                            <th class="text-nowrap">HR</th>
                                            <th class="text-nowrap">HE</th>
                                        </template>
                                        <th>Autorizador(es)</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-if="!isLodaded">
                                        <td colspan="18">
                                            <b>
                                                Cargando...
                                            </b>
                                        </td>
                                    </tr>
                                    <tr v-for="(employee, idx) in filteredEmployees" :key="idx">
                                        <td>{{ employee.name }} {{ employee.last_name }}</td>
                                        <td :class="employee.total_hours >= 48 ? 'bg-success text-white' : ''">
                                            <b>{{ employee.total_hours.toFixed(1) }} hrs</b>
                                        </td>
                                        <td><b>{{ employee.regular_hours.toFixed(1) }} hrs</b></td>
                                        <td :class="employee.extra_hours > 9 ? 'bg-danger text-white' : ''">
                                            <b>{{ employee.extra_hours.toFixed(1) }} hrs</b>
                                        </td>
                                        <template v-for="day in weekDays" :key="day.key">
                                            <td class="p-1 text-nowrap"
                                                :class="{ 'justified-absence': employee.hours[day.key]?.justified_absence }">
                                                {{ (employee.hours[day.key]?.hn)?.toFixed(1) ?? 0 }}
                                            </td>
                                            <td class="p-1 text-nowrap"
                                                :class="{ 'justified-absence': employee.hours[day.key]?.justified_absence }">
                                                {{ (employee.hours[day.key]?.he)?.toFixed(1) ?? 0 }}
                                            </td>
                                        </template>
                                        <td>
                                            <span v-if="employee.auth_by && employee.auth_by.length">
                                                {{ employee.auth_by.join(', ') }}
                                            </span>
                                            <span v-else>
                                                <b> - - - </b>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr v-if="noData">
                                        <td colspan="18">
                                            <b>
                                                No hay registros disponibles para las fechas seleccionadas
                                            </b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-7">
                <div class="card mt-4">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <div>
                                <h5 class="mb-2 ms-2">Colaboradores SIN registros enviados</h5>
                            </div>
                            <div>
                                <input type="text" v-model="searchNoTimeEmployee" class="form-control"
                                    placeholder="Buscar Colaborador...">
                            </div>
                            <div v-if="inventedVar">
                                <button class="btn btn-danger mb-0" @click="sendMultipleReminder()">Enviar recordatorios
                                    <i class="ni ni-send text-sm"></i></button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered text-center align-middle">
                                <thead>
                                    <tr>
                                        <th><b>Colaborador</b></th>
                                        <th><b>Equipo</b></th>
                                        <th><b>Autorizadores</b></th>
                                        <th><b>Acciones</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, idx) in paginatedEmployees" :key="idx">
                                        <td>{{ row.user_name }}</td>
                                        <td>{{ row.team }}</td>
                                        <td>
                                            {{
                                                row.authorizers.every(a => a.trim() === "")
                                                    ? "S/A"
                                                    : row.authorizers.filter(a => a.trim() !== "").join(", ")
                                            }}
                                        </td>
                                        <td>
                                            <button class="btn btn-small btn-warning mb-0"
                                                @click="sendReminder(row.user_id, row.user_name)">
                                                <i class="ni ni-send text-sm"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- Controles de paginación -->
                            <nav>
                                <ul class="pagination justify-content-center">
                                    <li class="page-item" :class="{ disabled: currentPageEmployees === 1 }">
                                        <button class="page-link"
                                            @click="changePageEmployees(currentPageEmployees - 1)">
                                            <i class="ni ni-bold-left text-sm"></i>
                                        </button>
                                    </li>

                                    <li class="page-item" v-for="page in totalPagesEmployees" :key="page"
                                        :class="{ active: currentPageEmployees === page }">
                                        <button class="page-link bg-warning text-white"
                                            @click="changePageEmployees(page)">{{
                                                page
                                            }}</button>
                                    </li>

                                    <li class="page-item"
                                        :class="{ disabled: currentPageEmployees === totalPagesEmployees }">
                                        <button class="page-link"
                                            @click="changePageEmployees(currentPageEmployees + 1)">
                                            <i class="ni ni-bold-right text-sm"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5">
                <div class="d-flex flex-column">
                    <div class="card mt-4">
                        <div class="p-3 pb-0 card-header">
                            <div class="d-flex flex-column flex-md-row justify-content-center">
                                <div>
                                    <h5 class="ms-2">Reporte Personalizado</h5>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="d-flex flex-column flex-md-row justify-content-center">
                                <div>
                                    <label for="custom-start-date">Fecha Inicio:</label><br>
                                    <input v-model="customStartDate" type="date" name="custom-start-date"
                                        id="custom-start-date" class="form-control">
                                </div>
                                <div class="ms-4">
                                    <label for="custom-start-date">Fecha Fin:</label><br>
                                    <input v-model="customEndDate" type="date" name="custom-end-date"
                                        id="custom-end-date" class="form-control">
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-lg-12 d-flex flex-column flex-md-row justify-content-center">
                                    <button class="btn btn-warning mb-0 w-60" @click="downloadCustomReport">Descargar
                                        Reporte <i class="bi bi-download"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-4">
                        <div class="p-3 pb-0 card-header">
                            <div class="d-flex flex-column flex-md-row justify-content-between">
                                <div>
                                    <h5 class="mb-2 ms-2">Bloqueo de Semanas</h5>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="d-flex flex-column flex-md-row justify-content-between align-items-end">
                                <div>
                                    <label for="custom-start-date">Inicio Semana (Lunes):</label><br>
                                    <input v-model="selectedLockDate" type="date" name="custom-start-date"
                                        id="custom-start-date" class="form-control" @change="calculateWeekRange">
                                </div>
                                <div>
                                    <label for="custom-start-date">Fin de Semana (Domingo):</label><br>
                                    <input v-model="lockEnd" type="date" name="custom-end-date" id="custom-end-date"
                                        class="form-control" readonly>
                                </div>
                                <div>
                                    <button class="btn btn-danger mb-0" @click="lockWeek"><span>
                                            Bloquear <i class="bi bi-ban"></i></span></button>
                                </div>
                            </div>
                            <div class="table-responsive mt-4">
                                <table class="table table-bordered text-center align-middle">
                                    <thead>
                                        <th>
                                            Inicio:
                                        </th>
                                        <th>
                                            Fin:
                                        </th>
                                        <th>
                                            Bloqueada por:
                                        </th>
                                        <th>
                                            Acciones
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(w, idx) in paginatedWeeks" :key=idx>
                                            <td>{{ formatDate(w.start_date) }}</td>
                                            <td>{{ formatDate(w.end_date) }}</td>
                                            <td>{{ w.user_name }}</td>
                                            <td><button class="btn btn-warning mb-0"
                                                    @click="unlockWeek(w.start_date, w.end_date, w.lock_id)">
                                                    <i class="bi bi-unlock"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- Controles de paginación -->
                                <nav>
                                    <ul class="pagination justify-content-center">
                                        <li class="page-item" :class="{ disabled: currentPageWeeks === 1 }">
                                            <button class="page-link" @click="changePageWeeks(currentPageWeeks - 1)">
                                                <i class="ni ni-bold-left text-sm"></i>
                                            </button>
                                        </li>

                                        <li class="page-item" v-for="page in totalPagesWeeks" :key="page"
                                            :class="{ active: currentPageWeeks === page }">
                                            <button class="page-link bg-warning text-white"
                                                @click="changePageWeeks(page)">{{
                                                    page
                                                }}</button>
                                        </li>

                                        <li class="page-item"
                                            :class="{ disabled: currentPageWeeks === totalPagesWeeks }">
                                            <button class="page-link" @click="changePageWeeks(currentPageWeeks + 1)">
                                                <i class="ni ni-bold-right text-sm"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card mt-4">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <div>
                                <h5 class="mb-2 ms-2">Tabla de autorizadores</h5>
                            </div>
                            <div style="width: 20%;" class="me-2">
                                <input type="text" class="form-control" v-model="searchEmployeeAuth"
                                    placeholder="Buscar Autorizador por Colaborador...">
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-if="!employeesAuth.length > 0">
                            No hay información disponible
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered text-center align-middle">
                                <thead>
                                    <tr>
                                        <th><b>Colaborador</b></th>
                                        <th><b>Autorizadores</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, idx) in filteredEmployeesAuth" :key="idx">
                                        <td>{{ row.user }}</td>
                                        <td>{{ row.authorizers && row.authorizers.length ? row.authorizers.join(', ') :
                                            '- - -' }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

import { computed, onMounted, ref, watch } from "vue"

// Zona horaria CDMX
const TIMEZONE = "America/Mexico_City"
// Base actual
const baseDate = ref(new Date())
// Obtener fecha CDMX
function getCDMXDate(date = new Date()) {
    const utc = date.toLocaleString("en-US", { timeZone: "UTC" })
    return new Date(
        new Date(utc).toLocaleString("en-US", { timeZone: TIMEZONE })
    )
}
// Generar semana actual
const weekStartDate = computed(() => getWeekStart(getCDMXDate(baseDate.value)))

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const employees = ref([])
const employeesAuth = ref([])
const noTimeEmployees = ref([])

const selectedLockDate = ref('');
const lockStart = ref("")
const lockEnd = ref("")

const inventedVar = ref(false)

const calculateWeekRange = () => {
    if (!selectedLockDate.value) return;

    const date = new Date(selectedLockDate.value + 'T00:00:00Z');

    // Obtener el día de la semana (0 = Domingo, 1 = Lunes, etc.)
    const day = date.getUTCDay();

    // Calcular el Lunes (día 1)
    const monday = new Date(date);
    monday.setUTCDate(date.getUTCDate() - (day === 0 ? 6 : day - 1));

    // Calcular el Domingo (día 0)
    const sunday = new Date(monday);
    sunday.setUTCDate(monday.getUTCDate() + 6);

    // Formatear a YYYY-MM-DD para asignar al input type="date"    
    lockStart.value = monday.toISOString().split('T')[0];
    lockEnd.value = sunday.toISOString().split('T')[0];

    selectedLockDate.value = lockStart.value

};

const lockWeek = async () => {

    if (!lockStart.value || !lockEnd.value) {
        alert('Primero selecciona una fecha.');
        return;
    }
    if (!confirm(`¿Estás segur@ de bloquear la semana del ${formatDate(lockStart.value)} al ${formatDate(lockEnd.value)}?`)) {
        return;
    }

    const body = {
        start: lockStart.value,
        end: lockEnd.value,
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/lock-week`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            alert('Semana Bloqueada')
            await getLockedWeeks()
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

const unlockWeek = async (start, end, lockId) => {

    if (!start || !end, !lockId) {
        alert('Error Inesperado')
        return;
    }

    if (!confirm(`¿Estás segur@ de DESBLOQUEAR la semana del ${formatDate(start)} al ${formatDate(end)}?`)) {
        return;
    }

    const body = { lock_id: lockId }

    try {
        const response = await axios.post(`${API_BASE_URL}/unlock-week`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            alert('Semana Desbloqueada')
            await getLockedWeeks()
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const lockedWeeks = ref([])

const isLodaded = ref(false)
const noData = ref(false)
const showDownloadButton = ref(false)

const searchEmployee = ref("")
const searchEmployeeAuth = ref("")
const searchNoTimeEmployee = ref("")

const filteredEmployees = computed(() => {
    const query = searchEmployee.value.toLowerCase();
    return employees.value.filter(e =>
        (e.name?.toLowerCase().includes(query) || e.last_name?.toLowerCase().includes(query))
    );
});

const filteredEmployeesAuth = computed(() => {
    const query = searchEmployeeAuth.value.toLowerCase();
    return employeesAuth.value.filter(e =>
        (e.user?.toLowerCase().includes(query) || e.last_name?.toLowerCase().includes(query))
    );
});

const filteredNoTimeEmployees = computed(() => {
    const query = searchNoTimeEmployee.value.toLowerCase();
    return noTimeEmployees.value.filter(e =>
        (e.user_name?.toLowerCase().includes(query))
    );
});

const usePagination = (data, itemsPerPage = 5) => {
    const currentPage = ref(1)
    const perPage = ref(itemsPerPage)

    // Total de páginas
    const totalPages = computed(() => {
        return Math.ceil(data.value.length / perPage.value)
    })

    // Datos de la página actual
    const paginatedData = computed(() => {
        const start = (currentPage.value - 1) * perPage.value
        const end = start + perPage.value
        return data.value.slice(start, end)
    })

    // Cambiar página
    const changePage = (page) => {
        if (page >= 1 && page <= totalPages.value) {
            currentPage.value = page
        }
    }

    // Resetear a la primera página cuando cambien los datos
    watch(data, () => {
        currentPage.value = 1
    })

    return {
        currentPage,
        perPage,
        totalPages,
        paginatedData,
        changePage
    }
}

// Paginación para la primera tabla (empleados)
const {
    currentPage: currentPageEmployees,
    totalPages: totalPagesEmployees,
    paginatedData: paginatedEmployees,
    changePage: changePageEmployees
} = usePagination(filteredNoTimeEmployees, 8)

// Paginación para la segunda tabla (semanas)
const {
    currentPage: currentPageWeeks,
    totalPages: totalPagesWeeks,
    paginatedData: paginatedWeeks,
    changePage: changePageWeeks
} = usePagination(lockedWeeks, 2)

const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const formatReportName = (start, end) => {
    const startObj = new Date(start);
    const endObj = new Date(end);

    const startDay = startObj.getUTCDate();
    const startMonth = months[startObj.getUTCMonth()];
    const endDay = endObj.getUTCDate();
    const endMonth = months[endObj.getUTCMonth()];
    const year = String(startObj.getUTCFullYear()).slice(-2);

    return `ReporteHrs ${startDay}${startMonth}-${endDay}${endMonth}-${year}`;
};

const weekDays = computed(() => {
    const days = []
    const labels = ["Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do"]
    const start = getMonday(weekStartDate.value)

    for (let i = 0; i < 7; i++) {
        const date = new Date(start.getTime())
        date.setDate(start.getDate() + i)
        const key = date.toISOString().split("T")[0] // yyyy-mm-dd
        const label = `${labels[i]} ${date.toLocaleDateString("es-MX", {
            day: "2-digit",
            month: "2-digit",
        })}`
        days.push({ key, label, date })
    }
    return days
})

const weekEndDate = computed(() => {
    const d = new Date(weekStartDate.value)
    d.setDate(d.getDate() + 6)
    return d
})

function formatToLocalYMD(date) {
    return date.toLocaleDateString("sv-SE", { timeZone: "America/Mexico_City" });
}

const startDate = ref(formatToLocalYMD(weekStartDate.value));
const endDate = ref(formatToLocalYMD(weekEndDate.value));

selectedLockDate.value = startDate.value
lockStart.value = startDate.value
lockEnd.value = endDate.value

const customStartDate = ref(formatToLocalYMD(weekStartDate.value));
const customEndDate = ref(formatToLocalYMD(weekEndDate.value));

// Obtener lunes de la semana
function getWeekStart(date) {
    const d = new Date(date)
    const day = d.getDay()
    const diff = d.getDate() - ((day + 6) % 7) // Lunes = 1
    return new Date(d.setDate(diff))
}

function getMonday(date) {
    const d = new Date(date)
    const day = d.getDay()
    const diff = d.getDate() - day + (day === 0 ? -6 : 1) // Ajusta si es domingo
    d.setDate(diff)
    return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}

// Cambiar semana
const changeWeek = (direction) => {
    const newDate = new Date(baseDate.value)
    newDate.setDate(newDate.getDate() + direction * 7)
    baseDate.value = newDate
    startDate.value = formatToLocalYMD(weekStartDate.value)
    endDate.value = formatToLocalYMD(weekEndDate.value)
    getTimes()
    getNoTimeSentUsers()
}

// Rango de fechas en el título

function formatRangeLabel(start, end) {
    const opciones = {
        weekday: "short",  // Día de la semana abreviado
        day: "numeric",    // Día del mes sin cero inicial
        month: "short"     // Mes abreviado
    }

    const startStr = start.toLocaleDateString("es-MX", opciones)
    const endStr = end.toLocaleDateString("es-MX", opciones)

    // Capitaliza la primera letra de cada palabra (por si toLocaleDateString devuelve en minúsculas)
    const capitalize = (str) => str.replace(/\b\w/g, c => c.toUpperCase())

    return `${capitalize(startStr)} - ${capitalize(endStr)}`
}

const formatDate = (date) => {
    if (!date) return '';

    let parsedDate;

    // Si ya es un objeto Date
    if (date instanceof Date) {
        parsedDate = date;
    }
    // Si es una cadena
    else if (typeof date === 'string') {
        // Si incluye "T", se asume formato ISO completo
        if (date.includes('T')) {
            parsedDate = new Date(date);
        } else {
            // Para 'YYYY-MM-DD', agregamos 'T00:00:00Z' para asegurar UTC
            parsedDate = new Date(date + 'T00:00:00Z');
        }
    } else {
        return '';
    }

    // Validación final
    if (isNaN(parsedDate.getTime())) return '';

    // Usar UTC para evitar retroceder un día
    const day = String(parsedDate.getUTCDate()).padStart(2, '0');
    const month = String(parsedDate.getUTCMonth() + 1).padStart(2, '0'); // Mes empieza en 0
    const year = parsedDate.getUTCFullYear();

    return `${day}/${month}/${year}`;
};


const downloadReport = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/download-period-report-2`, {
            start_date: startDate.value,
            end_date: endDate.value
        }, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        let fileName = formatReportName(startDate.value, endDate.value)

        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (err) {
        console.error('Error al descargar el reporte:', err);
    }
};

const downloadCustomReport = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/download-period-report-2`, {
            start_date: customStartDate.value,
            end_date: customEndDate.value
        }, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        let fileName = formatReportName(customStartDate.value, customEndDate.value)

        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (err) {
        console.error('Error al descargar el reporte:', err);
    }
};

const getTimes = async () => {

    const body = { start_date: startDate.value, end_date: endDate.value }

    try {
        const response = await axios.post(`${API_BASE_URL}/period-report-2`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            isLodaded.value = true
            if (response.data.data.length > 0) {
                noData.value = false
                showDownloadButton.value = true
                employees.value = response.data.data;
            } else {
                noData.value = true
                showDownloadButton.value = false
                employees.value = []
            }
        } else {
            isLodaded.value = false
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const getNoTimeSentUsers = async () => {
    const body = {
        start_date: startDate.value,
        end_date: endDate.value,
    }
    try {
        const response = await axios.post(`${API_BASE_URL}/get-no-time-sent-users`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            noTimeEmployees.value = response.data;
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

const getLockedWeeks = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-locked-weeks`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            lockedWeeks.value = response.data
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

const getEmployeesAndAuthorizers = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-users-and-authorizers`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            employeesAuth.value = response.data
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

const sendReminder = async (userId, name) => {

    alert(`Recordatorio enviado a ${name}`)

    const body = {
        user_id: userId,
        start_date: startDate.value,
        end_date: endDate.value
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/send-time-reminder`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            console.log(response.data)
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const sendMultipleReminder = async () => {

    if (!confirm('¿Estás segur@ de enviar recordatorio a todos los colaboradores seleccionados?')) {
        return;
    }

    alert('Recordatorios Enviados')

    const body = {
        allUsers: true,
        userIds: [],
        start_date: startDate.value,
        end_date: endDate.value
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/send-multiple-time-reminder`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            console.log(response.data)
        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

onMounted(async () => {
    await getTimes()
    await getEmployeesAndAuthorizers()
    await getLockedWeeks()
    await getNoTimeSentUsers()
});
</script>
<style scoped>
.justified-absence {
    background-color: #d1ecf1;
    font-weight: 500;
}

.justified-absence-indicator {
    background-color: #d1ecf1;
    color: gray;
}
</style>